require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-interviste-marco-sailer.json") })
        }
      }, "path---en-interviste-marco-sailer");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-interviste-marco-sailer!./.cache/json/en-interviste-marco-sailer.json
// module id = 591
// module chunks = 231608221292675